import React from "react";
import { useForm } from "react-hook-form";
import Input from "../../../../reusable-components/inputs/InputTextBox/Input";
import SubmitButton from "../../../../reusable-components/buttons/SubmitButton";
import Button from "../../../../reusable-components/buttons/Button";
import { button, cancel_button } from "../../../../theme/lightTheme";
import showToast from "../../../../utilities/notification/NotificationModal";
import useAuth from "../../../../authentication/hooks/useAuth";
import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import { EMP_DESIGNATION_URL } from "../../../../api/api_routing_urls";

export default function EmployeeDesignationForm({
  setShowAddForm,
  editEmpDesignationDetails,
  getEmpDesignationList,
  setEditEmpDesignationDetails,
}) {
  const { auth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const controller = new AbortController();

  let isEdit =
    editEmpDesignationDetails === undefined ||
    editEmpDesignationDetails === null
      ? false
      : Object?.keys(editEmpDesignationDetails)?.length > 0
      ? true
      : false;

  const defaultValues = {
    emp_designation: !isEdit ? "" : editEmpDesignationDetails?.emp_designation,
  };
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
    reset,
    setValue,
    control,
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
    criteriaMode: "all",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  const onSubmit = async (data) => {
    try {
      let response = "";
      let sendDataObj = {};

      sendDataObj.emp_designation = data?.emp_designation;
      if (!isEdit) {
        sendDataObj.createdby = auth.userid;

        response = await axiosPrivate.post(
          `${EMP_DESIGNATION_URL}/save`,
          sendDataObj,
          {
            signal: controller.signal,
          }
        );
      } else {
        sendDataObj.updatedby = auth.userid;
        sendDataObj.emp_designation_id =
          editEmpDesignationDetails?.emp_designation_id;

        response = await axiosPrivate.post(
          `${EMP_DESIGNATION_URL}/update`,
          sendDataObj,
          {
            signal: controller.signal,
          }
        );
      }

      if (response.status === 200) {
        if (isEdit) {
          showToast(
            "Employee Designation has been updated successfully",
            "success"
          );
        } else {
          showToast(
            "Employee Designation has been added successfully",
            "success"
          );
        }
        getEmpDesignationList();
      } else {
        if (isEdit) {
          if (
            response.data.saveEmpDesignationDetails.includes(
              "unique_desigantion"
            )
          ) {
            showToast(
              "Designation already exists. Cannot insert duplicate designation",
              "error"
            );
          } else {
            showToast(
              "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
              "error"
            );
          }
        } else {
          if (
            response.data.saveEmpDesignationDetails.includes(
              "unique_designation"
            )
          ) {
            showToast(
              "Designation already exists. Cannot insert duplicate designation",
              "error"
            );
          } else {
            showToast(
              "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
              "error"
            );
          }
        }
        return;
      }
      setShowAddForm(false);
      // reset();
    } catch (error) {
      console.error(error);
      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error"
        );
      }
    }
  };

  return (
    <>
      <section>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Input
            defaultName="emp_designation"
            register={register}
            name="Employee Desigantion"
            required={true}
            pattern={null}
            errors={errors}
            placeholder="Enter employee designation"
            setError={setError}
            clearError={clearErrors}
            autoComplete="off"
            type="text"
            classes={`rounded-lg px-3 py-2 text-sm w-full`}
            onChangeInput={null}
            defaultValue={defaultValues.emp_designation}
            setValue={setValue}
          />

          <div className="flex justify-between">
            <SubmitButton
              isSubmitting={isSubmitting}
              label={!isEdit ? "Submit" : "Update"}
              className={button}
            />
            <Button
              onClick={() => {
                setEditEmpDesignationDetails({});
                setValue("employee_designation", "");
                setShowAddForm(false);
              }}
              aria-label="Cancel Employee Designation Update Button"
              className={cancel_button}
            >
              Cancel
            </Button>
          </div>
        </form>
      </section>
    </>
  );
}
